// @flow

import moment from 'moment'

export const createOptionForDate = (d: moment, displayType: string) => {
  const date = moment.isMoment(d) ? d : moment.utc(d)
  return {
    date,
    displayType,
    isDisabled:
      displayType === 'months'
        ? date.isBefore(moment.utc().subtract(1, 'months'))
        : date.isBefore(moment.utc()),
    value: date.toDate(),
    label: date.calendar(null, {
      sameDay: '[Today] (Do MMM YYYY)',
      nextDay: '[Tomorrow] (Do MMM YYYY)',
      nextWeek: '[Next] dddd (Do MMM YYYY)',
      lastDay: '[Yesterday] (Do MMM YYYY)',
      lastWeek: '[Last] dddd (Do MMM YYYY)',
      sameElse: 'Do MMMM YYYY'
    })
  }
}

export const createMonthOptions = (date: moment = moment.utc()) => {
  // $FlowFixMe
  const months = Array.apply(null, {
    length: 12
  }).map((x, i) => {
    const d = moment
      .utc(date)
      .month(i)
      .startOf('month')
    return { ...createOptionForDate(d, 'months'), display: 'calendar' }
  })
  return {
    label: moment.utc(date).format('YYYY'),
    options: months
  }
}

export const createDayOptions = (date: moment = moment.utc()) => {
  // $FlowFixMe
  const daysInMonth = Array.apply(null, {
    length: moment.utc(date).daysInMonth()
  }).map((x, i) => {
    const d = moment
      .utc(date)
      .date(i + 1)
      .startOf('day')
    return { ...createOptionForDate(d, 'days'), display: 'calendar' }
  })
  return {
    label: moment.utc(date).format('MMMM YYYY'),
    options: daysInMonth
  }
}

export const getOptionStyles = (
  defaultStyles: Object,
  displayType: string,
  isDisabled: boolean,
  isSelected: boolean,
  isFocused: boolean
) => ({
  ...defaultStyles,
  display: 'inline-block',

  width: `${displayType === 'months' ? '22%' : '12%'}`,
  height: `${displayType === 'months' ? '55px' : 'inherit'}`,
  boxSizing: 'border-box',
  margin: `${displayType === 'months' ? '4px 4px' : '1px 1%'}`,
  textAlign: 'center',
  lineHeight: `${displayType === 'months' ? '35px' : '15px'}`,

  borderRadius: '4px',
  border: `${isSelected ? 'solid 1px #29dc8d' : 'solid 1px #d2d9e2'}`,
  backgroundColor: `${isSelected ? 'transparent' : isFocused ? 'transparent' : 'transparent'}`,
  backgroundImage: `${
    isDisabled
      ? 'linear-gradient(#f8f8f8, #f8f8f8)'
      : isSelected
      ? 'linear-gradient(#29dc8d, #29dc8d)'
      : 'none'
  }`,
  ':active': {
    backgroundColor: isSelected ? 'transparent' : 'transparent'
  },
  ':hover': {
    border: `${isDisabled ? 'solid 1px #d2d9e2' : 'solid 1px #C1E1BC'}`,
    backgroundImage: `${isDisabled ? '' : 'linear-gradient(#C1E1BC, #C1E1BC)'}`
  }
})

const daysHeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: '5px',
  width: '425px'
}
const headingStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '400px'
}
const titleStyles = {
  fontFamily: 'RelativeBook',
  fontSize: '16px'
}
const daysHeaderItemStyles = {
  color: '#4a5665',
  cursor: 'default',
  display: 'inline-block',
  width: '12%',
  margin: '0 1%',
  textAlign: 'center',
  fontFamily: 'RelativeBook',
  fontSize: '14px'
}
const daysContainerStyles = {
  padding: '5px 0'
}

export const styles = {
  daysHeaderStyles,
  headingStyles,
  titleStyles,
  daysHeaderItemStyles,
  daysContainerStyles
}



// WEBPACK FOOTER //
// ./src/components/SequentialDatePicker/helpers.js